/**
 * @fileoverview Service for OTP (One-Time Password) generation and validation
 */
class OTPService {
    storageKey = 'certiChain_otp';
    otpExpiration = 5 * 60 * 1000; // 5 minutes
    /**
     * Generate and send OTP to email
     */
    async sendOTP(email) {
        try {
            // Generate 6-digit OTP
            const otp = Math.floor(100000 + Math.random() * 900000).toString();
            // Store OTP with expiration
            const otpData = {
                email: email.toLowerCase(),
                otp,
                expiresAt: Date.now() + this.otpExpiration,
                attempts: 0,
            };
            localStorage.setItem(this.storageKey, JSON.stringify(otpData));
            // In production, this would send an email
            // For now, we'll log it to console for testing
            console.log(`OTP for ${email}: ${otp}`);
            // Simulate API call delay
            await new Promise(resolve => setTimeout(resolve, 500));
            return otp;
        }
        catch (error) {
            console.error('Error sending OTP:', error);
            throw new Error('Error al enviar el código de verificación');
        }
    }
    /**
     * Verify OTP
     * MOCKED: Accepts any OTP code for testing
     */
    verifyOTP(email, otp) {
        try {
            const stored = localStorage.getItem(this.storageKey);
            if (!stored) {
                // MOCKED: Accept any code if no stored OTP
                console.log('MOCK: No stored OTP, accepting any code for testing');
                return true;
            }
            const otpData = JSON.parse(stored);
            // Check email match
            if (otpData.email.toLowerCase() !== email.toLowerCase()) {
                console.log('MOCK: Email mismatch, but accepting for testing');
                return true; // MOCKED: Accept anyway
            }
            // MOCKED: Accept any OTP code (for testing purposes)
            console.log('MOCK: Accepting any OTP code for testing');
            console.log(`Expected: ${otpData.otp}, Received: ${otp}`);
            // OTP verified, remove it
            localStorage.removeItem(this.storageKey);
            return true;
        }
        catch (error) {
            console.error('Error verifying OTP:', error);
            // MOCKED: Accept anyway for testing
            console.log('MOCK: Error occurred, but accepting OTP for testing');
            return true;
        }
    }
    /**
     * Check if OTP exists and is valid for email
     */
    hasValidOTP(email) {
        try {
            const stored = localStorage.getItem(this.storageKey);
            if (!stored) {
                return false;
            }
            const otpData = JSON.parse(stored);
            if (otpData.email.toLowerCase() !== email.toLowerCase()) {
                return false;
            }
            if (Date.now() > otpData.expiresAt) {
                localStorage.removeItem(this.storageKey);
                return false;
            }
            return true;
        }
        catch (error) {
            return false;
        }
    }
    /**
     * Clear OTP
     */
    clearOTP() {
        localStorage.removeItem(this.storageKey);
    }
}
export const otpService = new OTPService();
